/**
 * What the ledger screens keep in the address bar, so a link, a reload or the back button returns
 * to the same book, tab and dates. Kept small: the router loads it with the shell.
 */
export const LEDGER_TABS = ['journal', 'accounts', 'trial', 'periods', 'verify'] as const;
export type LedgerTab = (typeof LEDGER_TABS)[number];

export interface LedgerSearch {
  readonly book?: string | undefined;
  readonly tab?: LedgerTab | undefined;
}

export interface StatementSearch {
  readonly from?: string | undefined;
  readonly to?: string | undefined;
}

const DATE = /^\d{4}-\d{2}-\d{2}$/;
const ID = /^[0-9a-f-]{36}$/i;

const text = (value: unknown, pattern: RegExp): string | undefined =>
  typeof value === 'string' && pattern.test(value) ? value : undefined;

export function ledgerSearch(input: Record<string, unknown>): LedgerSearch {
  const book = text(input.book, ID);
  const tab = LEDGER_TABS.find((t) => t === input.tab);
  return { ...(book ? { book } : {}), ...(tab ? { tab } : {}) };
}

export function statementSearch(input: Record<string, unknown>): StatementSearch {
  const from = text(input.from, DATE);
  const to = text(input.to, DATE);
  return { ...(from ? { from } : {}), ...(to ? { to } : {}) };
}
